import Auth from "@/services/auth";

const IfAuth = (to,from,next) => {
  if(Auth.loggedIn()){
    return next({
      path: '/dashboard'
    })
  }
  return next();
}

export default IfAuth;